import React, { useEffect, useState } from 'react';
import HisAlertColumn from './HisAlertColumn';
import ApiGo_TS from '../../../../actions/ApiGo_TS';
import HisMobilityDayChart from './HisMobilityDayChart';
import { useAppSelector } from '../../../../stores/hooks';
import UiIntegrater from '../littleUIComponent/UiIntegrater';
import { useTranslation } from 'react-i18next';
import HisMobilityByDays from './HisMobilityByDays';

interface NIBIF {
  NIB_acc: string;
  NIB_counts: string;
}
interface estimateIF extends NIBIF {
  past_ratio: any[];
  past_fs_observation_times_per_hour: any[];
  past_fs_observation_values_per_hour: any[];
  past_movement: any[];
  regression_line: any[];
  startTime: string;
  indicators_from_log: MobilityData;
}
interface residentIF {
  id: number;
  last_name: string;
  first_name: string;
}

interface MobilityData {
  notInBedCounts?: string;
  notInBedAcc?: string;
  lyingDownCounts?: string;
  lyingDownAcc?: string;
  sitCounts?: string;
  sitAcc?: string;
  turnoverCounts?: string;
  time_interval_count?: {};
}

const HisMobility = ({ data, activityData, days_open, setDays_open, daySwitch, setDaySwitch }: any): React.JSX.Element => {
  let resident: residentIF = data;
  const { t } = useTranslation();
  // ------- redux --------------------
  const store_timestamp = useAppSelector((state) => state.store_historyData.timestamp);
  const [mobilityData, setMobilityData] = useState({
    his_ratio: [] as any[],
    fs_observation_times: [] as any[],
    fs_observation_values: [] as any[],
    his_movement: [] as any[],
    regressionData: [] as any[],
    indicators: {
      notInBedCounts: '',
      notInBedAcc: '',
      lyingDownCounts: '',
      lyingDownAcc: '',
      sitCounts: '',
      sitAcc: '',
      turnoverCounts: '',
      time_interval_count: {},
    } as any,
  });

  useEffect(() => {
    fetchData();
  }, [store_timestamp, resident.id, activityData?.newResult]);

  //更新版mobilityData
  const fetchData = async () => {
    if (store_timestamp.length === 0) return;
    const dateTime = convertTimestamp(store_timestamp);
    try {
      const mobilityData = await ApiGo_TS.getMobilityEstimate<estimateIF>(resident.id, dateTime);
      setMobilityData({
        fs_observation_times: mobilityData.past_fs_observation_times_per_hour,
        fs_observation_values: mobilityData.past_fs_observation_values_per_hour,
        regressionData: mobilityData.regression_line,
        his_ratio: mobilityData.past_ratio,
        his_movement: mobilityData.past_movement,
        indicators: { time_interval_count: activityData },
      });
    } catch {
      setMobilityData((prevData) => ({ ...prevData, estimate: 0 }));
    }
  };
  return (
    <>
      <UiIntegrater OnOff_switch={[true, false, false, true, true]} date={new Date()} name={data !== undefined ? data.last_name : ''} bed={data !== undefined ? data.first_name : ''} fordays={true} days_open={days_open} setDays_open={setDays_open} daySwitch={daySwitch} setDaySwitch={setDaySwitch} page='dayChart'/>
      {days_open === 'FORDAYS' ? (
        <HisMobilityByDays data={data} daySwitch={daySwitch} />
      ) : (
        <div className="fx-d-c gap10 h-85">
          {/* <HisMobilityDayChart his_ratio={mobilityData.his_ratio} his_movement={mobilityData.his_movement} /> */}
          <div className="w-100 fx-d-r fx-aic h-15">
            <div className="w-100 fx-d-r gap10 h-100">
              <div className="w-100 fx-d-c fx-ccc pad-x-8 bg-blue" style={{ color: '#fbbc04' }}>
                <div className="font-m w-100" style={{textAlign:'center'}}>{t('HISTORY_RECORD.MOBILITY_SIT_COUNT')}</div>
                <div className="font-l bold">{activityData?.isOldData ? mobilityData.indicators?.sitCounts : activityData?.newResult?.sitUpCount[0]}</div>
              </div>
              <div className="w-100 fx-d-c fx-ccc pad-x-8 bg-blue" style={{ color: '#fbbc04' }}>
                <div className="font-m w-100" style={{textAlign:'center'}}>{t('HISTORY_RECORD.MOBILITY_SIT_TIME')}</div>
                <div className="font-l bold">{activityData?.isOldData ? mobilityData.indicators?.sitAcc : activityData?.newResult?.sitUpCount[1]}</div>
              </div>
              <div className="w-100 fx-d-c fx-ccc pad-x-8 bg-blue" style={{ color: '#34a853' }}>
                <div className="font-m w-100" style={{textAlign:'center'}}>{t('HISTORY_RECORD.MOBILITY_LIE_COUNT')}</div>
                <div className="font-l bold">{activityData?.isOldData ? mobilityData.indicators?.lyingDownCounts : activityData?.newResult?.lieDownCount[0]}</div>
              </div>
              <div className="w-100 fx-d-c fx-ccc pad-x-8 bg-blue" style={{ color: '#34a853' }}>
                <div className="font-m w-100" style={{textAlign:'center'}}>{t('HISTORY_RECORD.MOBILITY_LIE_TIME')}</div>
                <div className="font-l bold">{activityData?.isOldData ? mobilityData.indicators?.lyingDownAcc : activityData?.newResult?.lieDownCount[1]}</div>
              </div>
              <div className="w-100 fx-d-c fx-ccc pad-x-8 bg-blue" style={{ color: '#4285f4' }}>
                <div className="font-m w-100" style={{textAlign:'center'}}>{t('HISTORY_RECORD.MOBILITY_NIB_COUNT')}</div>
                <div className="font-l bold">{activityData?.isOldData ? mobilityData.indicators?.notInBedCounts : activityData?.newResult?.leaveBedCount[0]}</div>
              </div>
              <div className="w-100 fx-d-c fx-ccc pad-x-8 bg-blue" style={{ color: '#4285f4' }}>
                <div className="font-m w-100" style={{textAlign:'center'}}>{t('HISTORY_RECORD.MOBILITY_NIB_TIME')}</div>
                <div className="font-l bold">{activityData?.isOldData ? mobilityData.indicators?.notInBedAcc : activityData?.newResult?.leaveBedCount[1]}</div>
              </div>
              <div className="w-100 fx-d-c fx-ccc pad-x-8 bg-blue" style={{ color: '#ffab91' }}>
                <div className="font-m w-100" style={{textAlign:'center'}}>{t('HISTORY_RECORD.MOBILITY_ROLL_COUNT')}</div>
                <div className="font-l bold">{activityData?.isOldData ? mobilityData.indicators?.turnoverCounts : activityData?.newResult?.turnOverCount[0]}</div>
              </div>
              <div className="w-100 fx-d-c fx-ccc pad-x-8 bg-blue" style={{ color: '#ffab91' }}>
                <div className="font-m w-100" style={{textAlign:'center'}}>{t('HISTORY_RECORD.MOBILITY_ROLL_TIME')}</div>
                <div className="font-l bold">{activityData?.isOldData ? mobilityData.indicators?.turnoverCounts : activityData?.newResult?.turnOverCount[1]}</div>
              </div>
            </div>
          </div>
          <HisAlertColumn timesValuesData={mobilityData.fs_observation_times} observationValuesData={mobilityData.fs_observation_values} timeIntervalCount={mobilityData.indicators.time_interval_count} regressionData={mobilityData.regressionData} />
        </div>
      )}
    </>
  );
};

export default HisMobility;

//時間轉換API格式
export function convertTimestamp(timestamp: any) {
  const timestampDate = new Date(timestamp);
  const currentDate = new Date();

  const year = timestampDate.getFullYear();
  const month = String(timestampDate.getMonth() + 1).padStart(2, '0');
  const day = String(timestampDate.getDate()).padStart(2, '0');

  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}
